import { format } from 'date-fns'

export const formatDateToAppVersionFormat = date => {
  return format(date, 'yyyy-MM-dd-HH-mm')
}
